<a class="btn btn-flex flex-center btn-danger overflow-hidden text-nowrap px-0 h-40px w-100" (click)="logout()">

  <span class="btn-label">
    ออกจากระบบ
  </span>
</a>